import React from "react";
import StatusBox from "./statusBox";

class ContribStatus extends React.PureComponent {
  render() {
    const { contribType, data, data1, className } = this.props;
    let value = 0;
    let maxValue = 0;
    maxValue = data1.status.total;
    switch (contribType) {
      case "Experimental":
        value = data1.status.experimental;
        break;

      case "Beta":
        value = data.status.beta;
        break;

      case "Production":
        value = data.status.production;
        break;

      default:
        break;
    }

    const ratio = Math.round((value / maxValue) * 100);
    let progressClassName;
    if (value === 0) {
      progressClassName = "none";
    } else if (value > 0 && ratio <= 25) {
      progressClassName = "red";
    } else if (value === maxValue) {
      progressClassName = "green";
    } else {
      progressClassName = "orange";
    }

    return (
      <StatusBox
        className={className}
        progressClassName={progressClassName}
        blockName={contribType}
        value={value}
        maxValue={maxValue}
        ratio={ratio}
      />
    );
  }
}

export default ContribStatus;
